import axios from 'axios'
import { toast } from './toast.js'

const api = axios.create({
  baseURL: '/api/v1/frontoffice',
  withCredentials: true, // envia e recebe cookies automaticamente
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
})

// Interceptor de resposta — trata erros globais de forma consistente
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status

    if (status === 401) {
      // Sessão expirada — o router guard vai redirecionar para login
      window.dispatchEvent(new CustomEvent('auth:expired'))
    } else if (status === 500) {
      toast.error('Erro interno do servidor. Tente novamente.')
    }

    return Promise.reject(error)
  }
)

export default api
